import { EmptyView, EmptyViewButton } from '~components/EmptyView';
import { EmptyPowerScheduleIllustration } from '~components/ui/illustrations';

export function EmptyPowerSchedules({ handleCreate }: { handleCreate: () => void }) {
  return (
    <EmptyView icon={<EmptyPowerScheduleIllustration />} title="Create your first power schedule">
      <EmptyViewButton onClick={handleCreate} label="Create schedule" />
    </EmptyView>
  );
}
